export {default as Bookings} from './bookings/bookings.vue';
export {default as BookingDetail} from './booking-detail/bookingDetail.vue';
export {default as BookingNew} from './booking-new/bookingNew.vue';
export {default as AvailabilitiesIntro} from './availabilities/availabilities-intro';
export {default as AvailabilitiesByMonth} from './availabilities/availabilities-by-month';
export {default as AvailabilitiesByCampsite} from './availabilities/availabilities-by-campsite';
export {default as Campsites} from './campsites/campsites.vue';
export {default as CampsiteImages} from './campsite-images/campsiteImages';
export {default as Dashboard} from './dashboard/dashboard.vue';
export {default as Login} from './login/login.vue';
export {default as Profile} from './profile/profile.vue';
export {default as Seasons} from './seasons/seasons.vue';
export {default as Portals} from './portals/portals.vue';
export {default as Persons} from './persons/persons.vue';
export {default as Extras} from './extras/extras.vue';
export {default as Settings} from './settings/settings.vue';
export {default as Translations} from './translations/translations.vue';
export {default as Payments} from './payments/payments.vue';
export {default as Invoices} from './invoices/invoices.vue';
export {default as NotFound} from './not-found/not-found.vue';
export {default as CancellationTerms} from './cancellation-terms/cancellationTerms.vue';
export {default as CampsiteCalendar} from './campsite-calendar/campsite-calendar.vue';
export {default as PmsAccommodations} from './pms-accommodations/pms-accommodations.vue';
export {default as KbOverview} from './knowledge-base/kb-overview.vue';
export {default as KbTopic} from './knowledge-base/kb-topic.vue';
export {default as KbArticleEditor} from './knowledge-base/kb-article-editor.vue';



// WEBPACK FOOTER //
// ./src/views/pages/index.js